import { render, screen, within } from "@testing-library/react";
import "@testing-library/jest-dom";
import StatusChip, { statusColorFor } from "./StatusChip";

const colors = {
  Active: "success",
  Pending: "warning",
  Probation: "primary",
} as const;

describe("StatusChip", () => {
  it("picks the colour of the value, case-insensitively, and defaults to neutral", () => {
    expect(statusColorFor("Active", colors)).toBe("success");
    expect(statusColorFor("pending", colors)).toBe("warning");
    expect(statusColorFor("Vacant", colors)).toBe("neutral");
    expect(statusColorFor("Active", undefined)).toBe("neutral");
    // Inherited object names are not statuses.
    expect(statusColorFor("constructor", colors)).toBe("neutral");
    expect(statusColorFor("toString", colors)).toBe("neutral");
  });

  it("renders the value as a soft chip in its colour", () => {
    render(<StatusChip value="Active" statusColors={colors} />);
    const chip = screen.getByTestId("status-chip");
    expect(chip).toHaveAttribute("data-status-color", "success");
    expect(within(chip).getByText("Active")).toBeInTheDocument();
  });

  it("renders nothing for an empty value", () => {
    const { container } = render(<StatusChip value="" statusColors={colors} />);
    expect(container).toBeEmptyDOMElement();
  });
});
